import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import {
  fetchKeywordTrafficCoveragePage,
  type KeywordCoverageSort,
  type SortDirection,
} from '@/api/keywordCoverage/api'
import type { KeywordTrafficCoveragePage } from '@/api/keywordCoverage/types'

export function useKeywordTrafficCoverage(
  page: number,
  pageSize: number,
  sort: KeywordCoverageSort,
  direction: SortDirection,
): UseQueryResult<KeywordTrafficCoveragePage> {
  return useQuery({
    queryKey: ['keyword-traffic-coverage', page, pageSize, sort, direction],
    queryFn: ({ signal }) =>
      fetchKeywordTrafficCoveragePage(page, pageSize, sort, direction, signal),
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}
